import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, KeyValuePairs, Badge, Container, HelpPanel, SplitPanel, TokenGroup, FormField } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import CollectionPreferences from '@cloudscape-design/components/collection-preferences';
import ButtonDropdown from '@cloudscape-design/components/button-dropdown';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { formatPhone, storeJWT } from '../../../commons/functions';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import Icon from '@mdi/react';
import { mdiAllInclusiveBox, mdiHelpCircleOutline, mdiMenuRight, mdiMicrosoftXboxControllerView } from '@mdi/js';
import { helpPanelContent } from '../../1help-panel-content';

const pageSize = 20;

export const SecurityPoliciesPage = () => {
  const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { idControl, setIdControl } = useGlobalState();
  const [selectedRow, setSelectedRow] = useState<any>(null);  // Stores selected row data
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [sideOpen, setSideOpen] = useState(false);
  const [btnAuths, setBtnAuths] = useState(true);
  const [selectedPolicies, setSelectedPolicies] = useState<string[]>([]);
  const { JWT, setJWT } = useGlobalState();

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [selectedItems, setSelectedItems] = useState<PolicyItem[]>([]);
  const { setLoading } = useGlobalState();
  const [btnActionDisable, setBtnActionDisable] = useState<boolean>(true);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [filteringText, setFilteringText] = useState('');
  const [policies, setUsers] = useState<PolicyItem[]>([]);


  type PolicyUser = {
    idControl: number;
    displayName: string;
  }
  type PolicyAccess = {
    idAcceso: number;
    acceso: string;
  }
  type PolicyUnit = {
    idUnidad: number;
    unidad: string;
  }


  type PolicyItem = {
    idPolicy: number;
    policy: string;
    startTime: string;
    endTime: string;
    fechaInicio: string;
    fechaTermino: string;
    weekDay: string;
    weekDayString: string;
    users?: PolicyUser[];
    units?: PolicyUnit[];
    accesses?: PolicyAccess[];
  };
  const filteredPolicies = policies.filter(policy => {
    const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      policy.policy.toLowerCase().includes(word) ||
      policy.startTime.toLowerCase().includes(word) ||
      policy.endTime.toLowerCase().includes(word)
    );
  });

  const paginatedPolicies = filteredPolicies.slice(
    (currentPageIndex - 1) * pageSize,
    currentPageIndex * pageSize
  );

  const handleSelectionChange = ({ detail }: any) => {
    setSelectedItems(detail.selectedItems);
    setBtnActionDisable(detail.selectedItems.length === 0);
    if (detail.selectedItems.length > 1) setDrawerOpen(false);
  };

  useEffect(() => {
    setBtnAuths(selectedPolicies.length == 0)
  }, [selectedPolicies]); // The effect runs every time selectedAccesses changes

  // Handle row click to fetch additional data and open the HelpPanel

  useEffect(() => {
  }, [selectedRow]);
  const handleHelp = async () => {
    setHelpOpen(!helpOpen)
  }
  const handleRefresh = async () => {
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/list',
          'JWT': JWT,

        },
        body: JSON.stringify({
          users: true,
          accesses: true,
          units: true
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);
      setUsers(data.policies);

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePolicyDelete = async (policy: PolicyItem) => {
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/delete',
          'JWT': JWT,

        },
        body: JSON.stringify({
          idPolicy: policy.idPolicy,
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);
      handleRefresh(); // Refresh the policies list after deletion

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }

  }
  const handlePolicyDetail = async (policy: PolicyItem) => {
    //setSelectedRow(policy);  // Store selected row data
    try {
      // Simulate a fetch request to get additional data for the row
      // Example of a fetched data structure
      console.log(policy)
      setSelectedRow(policy);


    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setHelpOpen(false);
      setSideOpen(true);
      setDrawerOpen(true);
    }
  }
  useEffect(() => {
    handleRefresh();
  }, []);
  const allDays = [
    { num: '1', name: 'L' },
    { num: '2', name: 'M' },
    { num: '3', name: 'M' },
    { num: '4', name: 'J' },
    { num: '5', name: 'V' },
    { num: '6', name: 'S' },
    { num: '7', name: 'D' },
    { num: '0', name: 'F' }
  ];
  return (
    <CustomAppLayout
      toolsOpen={helpOpen}
      onToolsChange={({ detail }) => setHelpOpen(detail.open)}
      splitPanelOpen={sideOpen}
      onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}
      splitPanel={
        selectedRow && (
          <SplitPanel hidePreferencesButton header={selectedRow.policy} closeBehavior='hide'
          >
            <>
              <KeyValuePairs
                columns={2}
                items={[
                  {
                    label: "Horario",
                    value: `${selectedRow.startTime}-${selectedRow.endTime}`
                  },
                  {
                    label: "Días",
                    value: (

                      <SpaceBetween direction="horizontal" size="xs">
                        {selectedRow.weekDayString.includes('L') && <Badge>Lunes</Badge>}
                        {selectedRow.weekDayString.includes('M') && <Badge>Martes</Badge>}
                        {selectedRow.weekDayString.includes('W') && <Badge>Miércoles</Badge>}
                        {selectedRow.weekDayString.includes('J') && <Badge>Jueves</Badge>}
                        {selectedRow.weekDayString.includes('V') && <Badge>Viernes</Badge>}
                        {selectedRow.weekDayString.includes('S') && <Badge>Sábado</Badge>}
                        {selectedRow.weekDayString.includes('D') && <Badge>Domingo</Badge>}
                        {selectedRow.weekDayString.includes('F') && <Badge>Feriados</Badge>}
                      </SpaceBetween>
                    )
                  },
                  {
                    label: "Fecha Inicio",
                    value: selectedRow.fechaInicio === "" ? (
                      <>
                        <Icon path={mdiAllInclusiveBox} size={1} color={"gray"} /> Indefinido
                      </>
                    ) : (
                      selectedRow.fechaInicio
                    )
                  },
                  {
                    label: "Fecha Término",
                    value: selectedRow.fechaTermino === "" ? (
                      <>
                        <Icon path={mdiAllInclusiveBox} size={1} color={"gray"} /> Indefinido
                      </>
                    ) : (
                      selectedRow.fechaTermino
                    )
                  }
                ]}
              />
              <SpaceBetween size='xs' direction="vertical">
                {selectedRow.users && selectedRow.users.length > 0 && (
                  <FormField label="Usuarios">
                    <TokenGroup
                      readOnly
                      items={selectedRow.users.map((user: { displayName: any; }) => ({
                        label: user.displayName
                      }))}
                    />
                  </FormField>
                )}
                {selectedRow.units && selectedRow.units.length > 0 && (
                  <FormField label="Unidades">
                    <TokenGroup
                      readOnly
                      items={selectedRow.units.map((unit: { unidad: any; }) => ({
                        label: unit.unidad
                      }))}
                    />
                  </FormField>
                )}
                {selectedRow.acceses && selectedRow.acceses.length > 0 && (
                  <FormField label="Accesos">
                    <TokenGroup
                      readOnly
                      items={selectedRow.acceses.map((access: { acceso: any; }) => ({
                        label: access.acceso
                      }))}
                    />
                  </FormField>
                )}
              </SpaceBetween>

              <div style={{ height: '20px' }}></div>
              <SpaceBetween size='xs' direction="horizontal">
                <Button fullWidth variant='normal' onClick={() => {
                  handlePolicyDelete(selectedRow);
                  console.log("DELETE")
                  setSideOpen(false);
                }}>Eliminar</Button>
                <Button fullWidth variant='primary' href={`#security/policies.edit?id=${selectedRow.idPolicy}`}
                >Editar</Button>
              </SpaceBetween>
            </>
          </SplitPanel>
        )
      }

      tools={
        helpOpen && (
          <HelpPanel
            header={
              <Header variant="h2">Ayuda</Header>
            }
          ><p>Las políticas de seguridad permiten definir horarios y días específicos en los cuales el acceso se encuentra operativo.</p>

            <p> Cada una de las políticas puede ser <Link href='#security/assignment' variant="primary">asignada</Link> a uno o más accesos, unidades y/o usuarios, permitiendo una gestión flexible y adaptada a las necesidades de seguridad.</p>

          </HelpPanel>
        )
      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Seguridad', href: '#security' },
            { text: 'Políticas', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="xs" direction="vertical">

          <Table

            renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
              `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
            }
            onSelectionChange={handleSelectionChange}
            selectedItems={selectedItems}
            //onRowClick={({ detail }) => handleRowClick(detail.item)}
            ariaLabels={{
              selectionGroupLabel: "Items selection",
              allItemsSelectionLabel: () => "select all",
              itemSelectionLabel: ({ selectedItems }, item) => item.idPolicy.toString(),
            }}
            columnDefinitions={[
              {
                id: "policy",
                header: "Política",
                cell: (item) => <Link href={`#security/policies.edit?id=${item.idPolicy}`}>{item.policy}</Link>,
                sortingField: "policy",
                isRowHeader: true,
              },
              {
                id: "startTime",
                header: "Horario",
                cell: (item) => (<>{item.startTime}<Icon path={mdiMenuRight} size={1}></Icon>{item.endTime}</>),
                sortingField: "startTime",
              },
              {
                id: "weekDay",
                header: "Días",
                minWidth:240,
                cell: (item) => {
                  // Get the weekDayString from the current item, e.g., "135" or "0"
                  const itemWeekDays = item.weekDay;

                  return (
                    <SpaceBetween direction="horizontal" size="xxs">
                      {allDays.map(day => {
                        // Check if the current item's weekDayString includes this day's number
                        const isActive = itemWeekDays.includes(day.num);
                        const badgeColor = isActive ? 'blue' : 'severity-low'; // Cloudscape badge color variants

                        return (
                          <Badge key={day.num} color={badgeColor}>
                            {day.name}
                          </Badge>
                        );
                      })}
                    </SpaceBetween>
                  );
                },
              },
              {
                id: "view",
                header: "",
                cell: (item) => <Link variant="secondary" onClick={() => handlePolicyDetail(item)}><Icon path={mdiMicrosoftXboxControllerView} size={1.5}></Icon></Link>,
                width: 50,
              },
            ]}
            items={paginatedPolicies}
            selectionType={undefined}
            trackBy="idPolicy"
            empty={
              <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                <SpaceBetween size="m">
                  <b>No tiene políticas registradas</b>
                </SpaceBetween>
              </Box>
            }
            filter={
              <TextFilter
                filteringText={filteringText}
                onChange={({ detail }) => {
                  setFilteringText(detail.filteringText);
                  setCurrentPageIndex(1);
                }}
              />
            }
            pagination={
              paginatedPolicies.length > pageSize && (
                <Pagination
                  currentPageIndex={currentPageIndex}
                  pagesCount={Math.ceil(filteredPolicies.length / pageSize)}
                  onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                />
              )
            }

            header={
              <Header
                counter={
                  selectedItems.length
                    ? "(" + selectedItems.length + "/" + pageSize + ")"
                    : ""
                }
                info={<Link onClick={handleHelp}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                actions={
                  <SpaceBetween direction="horizontal" size="xs">
                    <Button variant="primary" href='#security/policies.add'>
                      Agregar Política
                    </Button>
                  </SpaceBetween>
                }
              >Políticas de Seguridad
              </Header>
            }
          />

        </SpaceBetween>
      }
    />
  );
};
